import {Notification} from "./Notification";
import {NotificationTypes} from "./NotificationTypes";
import {NotificationAdapter} from "./NotificationAdapter";

export class DefaultNotification extends Notification {
    protected _notificationType: symbol;
    protected _message: string;
    protected _notificationAdapter: NotificationAdapter;

    constructor(notificationAdapter: NotificationAdapter, notificationType: symbol, message: string) {
        super();
        this._notificationType = notificationType;
        this._message = message;
        this._notificationAdapter = notificationAdapter;
    }

    notify(): void {
        switch (this._notificationType) {
            case NotificationTypes.SUCCESS:
                this._notificationAdapter.success(this._message);
                break;
            case NotificationTypes.ERROR:
                this._notificationAdapter.error(this._message);
                break;
            case NotificationTypes.WARNING:
                this._notificationAdapter.warning(this._message);
                break;
            default:
                this._notificationAdapter.info(this._message);
                break;
        }
    }
}
